const COUNTRY_CODES = new Set(["us", "ca"]);

export function splitTeamId(teamId: string): { slug: string; gender: string } {
  const [slug, gender = ""] = teamId.split("|");
  return { slug, gender };
}

function titleCase(word: string): string {
  return word.charAt(0).toUpperCase() + word.slice(1);
}

/**
 * Turns a registry slug like `us-texas-christian-university-fort-worth-tx` into
 * "Texas Christian University Fort Worth TX". The trailing two-letter token is a
 * state/province code, so it is upper-cased rather than title-cased.
 */
export function formatSchoolName(slug: string): string {
  const parts = slug.split("-").filter(Boolean);
  if (parts.length > 1 && COUNTRY_CODES.has(parts[0])) parts.shift();
  if (parts.length === 0) return slug;
  if (parts.length === 1) return parts[0] === slug ? slug : titleCase(parts[0]);

  const last = parts.length - 1;
  return parts
    .map((word, index) =>
      index === last && word.length === 2 ? word.toUpperCase() : titleCase(word)
    )
    .join(" ");
}
